import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface EmptyStateProps {
  /** Icône lucide illustrative (optionnelle). */
  icon?: LucideIcon;
  /** Titre court de l'état vide. */
  title: string;
  /** Texte d'aide secondaire (optionnel). */
  description?: ReactNode;
  /** Bouton ou lien d'action (optionnel). */
  action?: ReactNode;
  className?: string;
}

/**
 * État vide partagé, style flat cohérent avec le tableau de bord :
 * icône encadrée, titre, description optionnelle et CTA optionnel.
 */
export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 py-8 text-center",
        className,
      )}
    >
      {Icon && (
        <span className="mada-state-ic flex h-12 w-12 items-center justify-center bg-muted/15 text-muted">
          <Icon className="h-6 w-6" aria-hidden />
        </span>
      )}
      <p className="mada-state-title text-sm font-medium text-muted-foreground">{title}</p>
      {description && <p className="max-w-xs text-xs text-muted">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
